import { render, staticRenderFns } from "./DocumentPhoto.vue?vue&type=template&id=ec0b43ac"
import script from "./DocumentPhoto.vue?vue&type=script&lang=ts"
export * from "./DocumentPhoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports